import { defineSlotRecipe } from '@chakra-ui/react/styled-system'

import { EAlertVariants } from '@/types/enum'

export const alertSlotRecipe = defineSlotRecipe({
  className: 'chakra-alert',
  slots: ['root', 'title', 'description', 'indicator', 'content'],
  base: {
    root: {
      width: 'full',
      display: 'flex',
      alignItems: 'flex-start',
      position: 'relative',
    },
    title: {
      fontSize: '14px',
      color: 'var(--color-text-primary)',
      lineHeight: '19px',
      fontWeight: 400,
    },
    description: {
      display: 'inline',
    },
    indicator: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: '1em',
      height: '1em',
      _icon: { boxSize: 'full' },
    },
    content: {
      display: 'flex',
      flex: 1,
      gap: '1',
    },
  },
  variants: {
    variant: {
      [EAlertVariants.default]: {
        root: {
          marginLeft: '16px',
          marginRight: '16px',
          w: '100%',
          p: '12px',
          borderRadius: '16px',
          boxShadow: '0px 24px 24px rgba(48, 46, 51, 0.3)',
          zIndex: 1000,
        },
      },
      [EAlertVariants.solid]: {
        root: {
          justifyContent: 'center',
          p: '15px',
          WebkitTransform: 'translate3d(0,0,200px)',
        },
        title: {
          fontSize: '13px',
          lineHeight: '17px',
          marginInlineEnd: 0,
          textAlign: 'center',
        },
      },
      [EAlertVariants.banner]: {
        root: {
          borderRadius: '16px',
          p: '12px',
          alignItems: 'flex-start',
        },
        title: {
          fontWeight: 900,
          fontSize: '13px',
          lineHeight: '16px',
          color: 'var(--color-text-primary)',
        },
        description: {
          display: 'block',
          fontWeight: 400,
          fontSize: '13px',
          lineHeight: '16px',
          color: 'var(--color-text-primary)',
          marginTop: '4px',
          marginRight: '8px',
        },
      },
    },
  },
  defaultVariants: {
    variant: EAlertVariants.default,
  },
})
